import { isPlatformBrowser } from '@angular/common';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { KeycloakAuthService } from '../services/keycloak/keycloak-auth.service';
import { environment } from 'environments/environment';

const isJwt = (token: string | null | undefined): token is string =>
  typeof token === 'string' && token.startsWith('ey');

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly keycloakAuthService: KeycloakAuthService,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const apiBaseUrl = environment.apiURL.replace(/\/$/, '');
    if (!req.url.startsWith(apiBaseUrl)) {
      return next.handle(req);
    }

    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(req);
    }

    return from(this.keycloakAuthService.getValidToken()).pipe(
      map((accessToken) => (isJwt(accessToken) ? accessToken : '')),
      map((token) =>
        token
          ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
          : req,
      ),
      switchMap((authReq) => next.handle(authReq)),
    );
  }
}
